import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "../components/Reveal";

export const ChristmasBanner = () => {
  const nav = useNavigate();
  const go = () => {
    nav("/?cat=Christmas");
    setTimeout(() => {
      const el = document.getElementById("shop");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 350);
  };
  return (
    <section className="relative overflow-hidden border-y border-white/10 bg-[#12080A] px-5 py-16 md:px-12 md:py-24" data-testid="christmas-banner">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_85%_30%,rgba(255,42,85,0.28),transparent_55%),radial-gradient(circle_at_10%_80%,rgba(0,255,102,0.14),transparent_50%)]" />
      <div className="relative mx-auto grid max-w-[1600px] items-center gap-10 md:grid-cols-2">
        <Reveal>
          <Eyebrow className="!text-[#FF2A55]">Limited · Christmas Design</Eyebrow>
          <h2 className="mt-4 font-display text-6xl font-black uppercase leading-[0.85] tracking-tight md:text-8xl">
            Merry<br /><span className="text-[#FF2A55]">Drop</span>-Mas
          </h2>
          <p className="mt-6 max-w-md text-zinc-300">Four gingerbread colourways, snowflakes and candy canes — all-over printed on 240 GSM biowash cotton. Serve looks at the dinner table.</p>
          <button data-testid="christmas-shop-btn" onClick={go} className="mt-8 bg-[#FF2A55] px-7 py-4 font-display text-2xl font-black uppercase text-black transition-colors hover:bg-white">
            Shop Christmas
          </button>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative mx-auto max-w-[420px]">
            <div className="clip-notch relative aspect-[3/4] overflow-hidden bg-[#1b1b1f]">
              <img src="/img/x3.jpg" alt="Santa red gingerbread all-over print tee" className="h-full w-full object-cover" />
            </div>
            <motion.div animate={{ y: [0, -8, 0] }} transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }} className="absolute -right-2 top-6 border border-white/20 bg-black/80 px-3 py-2 font-mono text-xs uppercase backdrop-blur-xl md:-right-6">4 Colourways</motion.div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};